export default __webpack_public_path__ + "static/media/doubleLegSquatAvatar.3023b87d.png";